import { ComponentProps, SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { Link, ReactNode } from '@tanstack/react-router';
import { match } from 'ts-pattern';
import {
  actionButtonStyles,
  ActionButtonStylesVariants,
} from '../actionButton/variants';

export type ActionButtonProps = {
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
} & ActionButtonStylesVariants &
  Omit<ComponentProps<typeof Link>, 'className' | 'children' | 'color'>;

export function ActionButtonLink(props: ActionButtonProps) {
  const { icon: Icon, size = 'large', className, ...rest } = props;

  return (
    <Link
      className={twMerge(actionButtonStyles({ size }), className)}
      {...rest}
    >
      <Icon className={mapSizeToIconSize(size)} />
    </Link>
  );
}

function mapSizeToIconSize(size: ActionButtonStylesVariants['size']): string {
  return match(size)
    .returnType<string>()
    .with('large', () => 'min-w-24 w-24 h-24')
    .with('small', () => 'min-w-16 w-16 h-16')
    .otherwise(() => 'min-w-24 w-24 h-24');
}
